import commonApi from '../api/commonApi'
import { LOCAL_STORAGE_KEY, ID_SIGN_AND_DOWNLOAD_PDF_CB_URL, ID_SIGN_COMPLETE_CB_URL } from '../constant/constant'
import { setStorage, getStorage } from '../utils/storageUtil'
import { parseJwt } from '@/utils/utils'
import { getAuthCode } from '@/utils/govappUtil'
// import urlUtil from '@/utils/urlUtil'

const GET_SIGN_LINK_URL = 'getSignLinkURL'
const SIGN_AND_START_WORKFLOW_URL = 'signAndStartWorkflowUrl'
const REDIRECT_PATH = 'redirectPath'
const POST_FORM = 'postForm'
const SUCCESS_MSG_KEY = 'successMsgKey'
const FAIL_MSG_KEY = 'failMsgKey'
// const DOCUMENT_ID = 'documentId'
const isApp = process.env.VUE_APP_MODE === 'APP'

async function signAndStartWorkflow (data) {
  // get the esigntrust singing link
  await commonApi.post(data[GET_SIGN_LINK_URL], data[POST_FORM], cb => {
    if (cb.status === 201 || cb.status === 200) {
      let url = '' // the url get from backend inclue formCode
      let redirectUri = ''
      let authCode = '' // authorize code got from govapp tools
      let formCode = '' // Gen by backend api
      let euid = parseJwt(getStorage(LOCAL_STORAGE_KEY.G2E_JWT_TOKEN)).euid
      setStorage(LOCAL_STORAGE_KEY.SIGN_OBJ, JSON.stringify(data))
      url = cb.data
      if (isApp) {
        if (url) {
          formCode = url.substring(url.indexOf('formCode')).split('=')[1]
        }
        redirectUri = ID_SIGN_COMPLETE_CB_URL + '?formCode=' + formCode
        getAuthCode(euid, redirectUri, formCode, resp => {
          authCode = resp
          url = ID_SIGN_COMPLETE_CB_URL + '?code=' + authCode + '&formCode=' + formCode
          // url = 'http://localhost:8080/ext/app/idSignAndCompleteCbReceiver' + '?code=' + authCode + '&formCode=' + formCode
          console.log('signAndStartWorkflow: ' + url)
          location.href = url
        })
      } else {
        console.log('signAndStartWorkflow: ' + url)
        location.href = url
      }
    }
  })

  return false // return false for stop loading
}

async function signAndDownloadPdf (data) {
  await commonApi.post(data[GET_SIGN_LINK_URL], data[POST_FORM], cb => {
    if (cb.status === 201 || cb.status === 200) {
      data[POST_FORM] = {
        'processId': data[POST_FORM].processId,
        'accountType': 'GOV_ENTITY',
        'documentId': cb.data.documentId,
        'euid': parseJwt(getStorage(LOCAL_STORAGE_KEY.G2E_JWT_TOKEN)).euid,
        'identityLevel': 'SATISFACTORY',
        'items': [
          {
            'field': 'signature-1',
            'filename': 'instructionHistory.pdf'
          }
        ],
        'redirectUrl': ID_SIGN_AND_DOWNLOAD_PDF_CB_URL,
        'signatureFieldName': 'signature-1'
      }

      setStorage(LOCAL_STORAGE_KEY.SIGN_OBJ, JSON.stringify(data))
      location.href = cb.data.link
    }
  })

  return false // return false for stop loading
}

export default { GET_SIGN_LINK_URL, SIGN_AND_START_WORKFLOW_URL, REDIRECT_PATH, POST_FORM, SUCCESS_MSG_KEY, FAIL_MSG_KEY, signAndStartWorkflow, signAndDownloadPdf }

export { GET_SIGN_LINK_URL, SIGN_AND_START_WORKFLOW_URL, REDIRECT_PATH, POST_FORM, SUCCESS_MSG_KEY, FAIL_MSG_KEY, signAndStartWorkflow, signAndDownloadPdf }
